/**
 * vue-qrcode-reader / barcode-detector load ZXing WASM from jsDelivr by default.
 * If that CDN is blocked (CSP, network, referrer), QR detection never starts — often with no visible error.
 * Serve WASM from the app bundle via Vite instead. See: https://github.com/gruhn/vue-qrcode-reader/issues/456
 */
import { setZXingModuleOverrides } from 'vue-qrcode-reader';
import zxingReaderWasmUrl from 'zxing-wasm/reader/zxing_reader.wasm?url';

setZXingModuleOverrides({
  locateFile(path, prefix) {
    if (path.match(/_(.+?)\.wasm$/)) {
      // console.warn('[QR] zxing WASM resolve (bundled)', zxingReaderWasmUrl);
      return zxingReaderWasmUrl;
    }
    return prefix + path;
  }
});

// console.warn('[QR] setZXingModuleOverrides installed');
